import { useAuth } from '../../App'
import { Divider } from '../misc'
import { usePreferences as usePreference } from '@/hooks/usePreference'
import { toast, Toaster } from 'sonner'
import { DashboardLayoutOption } from './UI/DashboardLayoutOption'
import { DarkModeOption } from './UI/Dark Mode Option'

export default function SettingsPage() {
    const { user } = useAuth()
    const { 
        preferences, 
        setPreference, 
        savePreferences, 
        error,
        getAvailablePreferences
    } = usePreference(user)

    const onSubmit = async () => {
        await savePreferences()

        if (error) {
            toast.error("Error saving preferences")
        } else {
            toast.success("Preferences saved successfully")
        }
    }

  return (
    <div className='flex flex-col gap-4 p-5'>
        <h1>Settings</h1>

        <Divider />

        <div className='flex flex-col gap-4'>
            <h2>User Preferences:</h2>
            <div className='flex flex-col gap-4'>
                <DarkModeOption preferences={preferences} setPreference={setPreference} />
                <DashboardLayoutOption preferences={preferences} availableSections={getAvailablePreferences()} setPreference={setPreference} />
            </div>
        </div>

        <div className='flex flex-col gap-4 mt-4'>
            <button 
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                onClick={onSubmit}
            >
                Save Preferences
            </button>

            <Toaster expand richColors/>
        </div>
    </div>
  )
}